import {
  env,
  ENV_PRODUCTION,
  IS_IN_HOUSE_MASTER,
  IS_DEV,
  IS_STAGING,
  IS_AZURE_DEV,
  IS_AZURE_QA,
  IS_AZURE_PROD
} from '../env';

export const getBaseUrl = function() {
  
  if (process.env && process.env[IS_DEV]) {
    return 'https://devapi.mealsplus.com/';
  }

  if (process.env && process.env[IS_STAGING]) {
    return 'https://devapi.mealsplus.com/';
  }

  if (process.env && process.env[IS_IN_HOUSE_MASTER]) {
    return 'https://uatapi.mealsplus.com';
  }

  if (process.env && process.env[IS_AZURE_DEV]) {
    // This is temporary, once we have a registered dns this will change
    return 'https://mpw-api-container.azurewebsites.net';
  }

  if (process.env && process.env[IS_AZURE_QA]) {
        // This is temporary, once we have a registered dns this will change
    return 'https://mpwapi.eastus.cloudapp.azure.com';
  }

  if (process.env && process.env[IS_AZURE_PROD]) {
    return 'https://nutritionapi.linq.com';
  }

  switch (env) {
    case ENV_PRODUCTION:
      return 'https://snapi.linq.com';
    default:
      return process.env.REACT_APP_API_URL; // To use a local environment variable duplicate .env.local.example and rename it to .env.local
  }
};

const baseUrl = getBaseUrl();

export { baseUrl };



// WEBPACK FOOTER //
// ./src/api/Connection.js